import React from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const lang = 'fr'; // or 'ar'

const HeaderRow = tw.div`flex justify-between items-center flex-col xl:flex-row`;

const Header = styled.h2`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: #336734;
  position: relative;
  width: 100%;

  &::before,
  &::after {
    content: "";
    width: 90px;
    border-bottom: 2px solid #d3d3d3;
    margin: 0 1rem;
  }
`;

const TabContent = tw(motion.div)`mt-6 flex flex-wrap sm:-mr-10 md:-mr-6 lg:-mr-12`;
const CardContainer = tw.div`mt-10 w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 sm:pr-10 md:pr-6 lg:pr-12`; 
const Card = tw(motion.div)`rounded-b block max-w-xs mx-auto sm:max-w-none sm:mx-0 mb-0`;

const CardImageContainer = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`h-56 xl:h-64 bg-center bg-cover relative rounded-t`}
`;

const CardText = tw.div`p-4 text-gray-900`;
const CardTitle = tw.h5`text-sm font-bold text-center text-[#000000]`;
const CardPrice = tw.p`mt-2 text-base font-semibold text-center text-[#336734]`;
const CardButtonContainer = tw.div`flex justify-center mt-3`;
const CardButton = tw(PrimaryButtonBase)`text-sm`;

const ProductTabs = ({ heading = "Nos produits", products = [] }) => {
console.log(products);
  const role = localStorage.getItem("role");
  const navigate = useNavigate();
const { t, i18n } = useTranslation();
const getLangValue = (field) => {
  const parsed = parseJsonIfNeeded(field);

  if (!parsed) return "";
  if (typeof parsed === "object") {
    return parsed[i18n.language] || parsed.fr || "";
  }
  return parsed;
};
const parseJsonIfNeeded = (value) => {
  if (!value) return null;
  if (typeof value === "string") {
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
  return value;
};


  const handleGoToProduct = (card) => {
const productName = getLangValue(card.Name);
const slug = encodeURIComponent(
  productName.replace(/\s+/g, "-").toLowerCase()
);
    navigate(`/product-details/${card.ProductID}-${slug}`);
  };

  return (
    <Container style={{ marginTop: "-50px" }}>
      <ContentWithPaddingXl>
        <HeaderRow>
          <Header>{heading}</Header>
        </HeaderRow>
        <TabContent>
          {products.length > 0 ? (
            products.map((card) => {
const productName = getLangValue(card.Name);
              return (
                <CardContainer key={card.ProductID}>
                  <Card className="group" initial="rest" whileHover="hover" animate="rest">
 <div 
              onClick={() => handleGoToProduct(card)} 
              style={{ cursor: "pointer" }}
            >
                    <CardImageContainer
                      imageSrc={`https://elanciabioapi.com/storage/${card.image}`}
                    />
            </div>

                    <CardText>
                      <CardPrice>
                        {role === "supplier"
                          ? `${card.distributeur_price || 0} MAD`
                          : `${card.user_price || 0} MAD`}
                      </CardPrice>
                      <CardTitle>{productName}</CardTitle>

                      <CardButtonContainer>
                        <CardButton onClick={() => handleGoToProduct(card)}>
                         <i className="bi bi-cart-plus"></i> {t("add_to_cart")}
                        </CardButton>
                      </CardButtonContainer>
                    </CardText>
                  </Card>
                </CardContainer>
              );
            })
          ) : (
<p>{t("no_products")}</p>
          )}
        </TabContent>
      </ContentWithPaddingXl>
    </Container>
  );
};

export default ProductTabs;
